import * as tslib_1 from "tslib";
import { observer } from 'mobx-react';
import selectForwardMeetingNotificationOption from '../actions/selectForwardMeetingNotificationOption';
import * as React from 'react';
import { OptionsCheckbox } from 'owa-options-controls';
import strings from 'owa-strings/owa-options-strings';
import getForwardMeetingNotificationOption from '../selectors/getForwardMeetingNotificationOption';
/**
 * Specifies the option to toggle the delete forward meeting notifications under the invitation settings
 */
var DeleteMeetingForwardNotificationOption = /** @class */ (function (_super) {
    tslib_1.__extends(DeleteMeetingForwardNotificationOption, _super);
    function DeleteMeetingForwardNotificationOption() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onForwardMeetingNotificationSettingChange = function (ev, checked) {
            selectForwardMeetingNotificationOption(checked);
        };
        return _this;
    }
    DeleteMeetingForwardNotificationOption.prototype.render = function () {
        var forwardMeetingNotificationOption = getForwardMeetingNotificationOption();
        return (React.createElement(OptionsCheckbox, { label: strings.options_delete_forwarded_event_notifications, checked: forwardMeetingNotificationOption, onChange: this.onForwardMeetingNotificationSettingChange }));
    };
    DeleteMeetingForwardNotificationOption = tslib_1.__decorate([
        observer
    ], DeleteMeetingForwardNotificationOption);
    return DeleteMeetingForwardNotificationOption;
}(React.Component));
export default DeleteMeetingForwardNotificationOption;
//# sourceMappingURL=DeleteMeetingForwardNotificationOption.js.map